<!-- Маленькая кликабельная ссылка на сущность для карточек, списков и таблиц -->
<template>
  <component
    :is="clickable ? 'RouterLink' : 'span'"
    class="entity-link"
    :class="{ 'entity-link--clickable': clickable }"
    :to="clickable ? { name: routeName, params: { id: entityId } } : undefined"
    :target="clickable && newTab ? '_blank' : undefined"
    :rel="clickable && newTab ? 'noopener noreferrer' : undefined"
    :title="[title, subtitle].filter(Boolean).join(' · ')"
  >
    <span v-if="$slots.icon" class="entity-link__icon">
      <slot name="icon" />
    </span>
    <span class="entity-link__content">
      <span class="entity-link__title">
        <slot>{{ title }}</slot>
      </span>
      <span v-if="subtitle" class="entity-link__subtitle">
        {{ subtitle }}
      </span>
    </span>
  </component>
</template>

<script>
export default {
  name: "BaseEntityLink",
  props: {
    clickable: { type: Boolean, default: true },
    // Открывает ссылку в новой вкладке, сохраняя текущий экран пользователя.
    newTab: { type: Boolean, default: false },
    routeName: {
      type: String,
      default: null,
    },
    entityId: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.entity-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  min-width: 0;
  padding: 3px 5px;
  color: inherit;
  text-decoration: none;
  border-radius: 6px;
  vertical-align: middle;
}

.entity-link--clickable:hover {
  background: #eef6f1;
}

.entity-link__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.entity-link__content {
  display: inline-flex;
  flex-direction: column;
  min-width: 0;
}

.entity-link__title,
.entity-link__subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.entity-link__title {
  color: var(--color-dark);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
}

.entity-link__subtitle {
  color: #64748b;
  font-size: 11px;
  line-height: 1.2;
}
</style>
